(() => {
  const language = document.documentElement.lang.toLowerCase().split('-')[0];
  const labels = { it: 'Chi siamo', en: 'About us', fr: 'À propos' };
  const contactLabels = { it: 'contatti', en: 'contact', fr: 'contact' };
  const aboutLabel = labels[language] || labels.en;
  const contactLabel = contactLabels[language] || contactLabels.en;
  const root = window.Shopify?.routes?.root || '/';
  const aboutUrl = `${root}pages/contact?view=chi-siamo`;

  const updateAboutLink = () => {
    const header = document.querySelector('#header-component');
    if (!header) return;

    header.querySelectorAll('a[href]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      if (url.pathname !== '/pages/contact') return;

      link.href = aboutUrl;

      const textNodes = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      let textNode = textNodes.nextNode();

      while (textNode) {
        if (textNode.nodeValue.trim().toLowerCase() === contactLabel) {
          textNode.nodeValue = aboutLabel;
        }
        textNode = textNodes.nextNode();
      }

      if (link.getAttribute('aria-label')?.toLowerCase() === contactLabel) {
        link.setAttribute('aria-label', aboutLabel);
      }
    });
  };

  updateAboutLink();
  document.addEventListener('shopify:section:load', updateAboutLink);

  const headerGroup = document.querySelector('#header-group');
  if (!headerGroup) return;

  new MutationObserver(updateAboutLink).observe(headerGroup, {
    childList: true,
    subtree: true,
  });
})();
